export default __webpack_public_path__ + "static/media/business360app.470248ea.png";